import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import VideoGridSection from './components/VideoGridSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import AboutBrandSection from './components/AboutBrandSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategorySection />
      <VideoGridSection />
      <TestimonialSection />
      <CTASection />
      <AboutBrandSection />
    </main>
  );
}